export const TOGGLE_FETCHING_ANALYSIS = "TOGGLE_FETCHING_ANALYSIS";
export const SET_ANALYSIS = "SET_ANALYSIS";

export const TOGGLE_FETCHING_CHART_ANALYSIS = "TOGGLE_FETCHING_CHART_ANALYSIS";
export const SET_CHART_ANALYSIS = "SET_CHART_ANALYSIS";

export const TOGGLE_FETCHING_TRANSACTIONS_ANALYSIS =
  "TOGGLE_FETCHING_TRANSACTIONS_ANALYSIS";
export const SET_TRANSACTIONS_ANALYSIS = "SET_TRANSACTIONS_ANALYSIS";
